import React, { useState } from 'react';
import { 
  ThemeProvider, 
  CssBaseline, 
  Box,
  Container,
  AppBar,
  Toolbar,
  Grid,
  Button,
  Stack
} from '@mui/material';
import theme from './theme';
import DataPrivySite from './DataPrivySite';
// Import logo
import logo from './images/DataPrivyLogo2.png';

function App() {
  const [activeSection, setActiveSection] = useState('home');

  const scrollToSection = (section) => {
    setActiveSection(section);
    document.getElementById(section).scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* Navigation */}
      <Box sx={{ 
        position: 'fixed', 
        top: { xs: 8, sm: 16 }, 
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        zIndex: 1100
      }}>
        <Container maxWidth="lg" sx={{ position: 'relative', mb: 2, px: { xs: 2, sm: 3 } }}>
          <AppBar 
            position="relative"
            sx={{ 
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.15)',
              borderRadius: 1,
              width: '100%',
              marginLeft: '-7.5px',
              transition: 'all 0.3s ease-in-out',
              '&:hover': {
                boxShadow: '0px 6px 25px rgba(0, 0, 0, 0.2)',
              }
            }}
          >
            <Toolbar sx={{ p: { xs: 1, sm: 1.5 }, minHeight: '64px' }}>
              <Grid container alignItems="center" justifyContent="space-between">
                {/* Logo - left column */}
                <Grid item xs={2} sm={2} md={2} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <img 
                    src={logo} 
                    alt="DataPrivy Logo" 
                    style={{ height: '32px', cursor: 'pointer' }} 
                    onClick={() => scrollToSection('home')}
                  />
                </Grid>
                
                {/* Navigation - center column */}
                <Grid item xs={8} sm={8} md={8} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Stack direction="row" spacing={{ xs: 0.5, sm: 1 }} sx={{ width: 'auto', justifyContent: 'center' }}>
                    <Button 
                      color="primary"
                      variant={activeSection === 'home' ? 'contained' : 'text'}
                      onClick={() => scrollToSection('home')}
                    >
                      Home
                    </Button>
                    <Button 
                      color="primary"
                      variant={activeSection === 'features' ? 'contained' : 'text'}
                      onClick={() => scrollToSection('features')}
                    >
                      Features
                    </Button>

                    <Button 
                      color="primary"
                      variant={activeSection === 'regulations' ? 'contained' : 'text'}
                      onClick={() => scrollToSection('regulations')}
                    >
                      Regulations
                    </Button>
                    
                    <Button 
                      color="primary"
                      variant={activeSection === 'how-it-works' ? 'contained' : 'text'}
                      onClick={() => scrollToSection('how-it-works')}
                    >
                      How It Works
                    </Button>
                    
                    <Button 
                      color="primary"
                      variant={activeSection === 'faq' ? 'contained' : 'text'}
                      onClick={() => scrollToSection('faq')}
                    >
                      FAQ
                    </Button>
                  </Stack>
                </Grid>
                
                {/* Right column - empty for balance */}
                <Grid item xs={2} sm={2} md={2}></Grid>
              </Grid>
            </Toolbar>
          </AppBar>
        </Container>
      </Box>
      <DataPrivySite />
    </ThemeProvider>
  );
}

export default App;
